<template>
    <div class="row"
         id="hems"
         v-if="hemsResult.length > 0">
        <div class="col-12"
             v-if="!isShared">
            <div v-for="(result, index) in hemsResult"
                 :key="index">
                <div class="col-12 row-card d-flex justify-content-between py-3"
                     :class="{ 'bg-success': !below[index], 'bg-warning': below[index] }">
                    <span>
                        <strong style="text-transform: uppercase">
                            HEM Benchmark {{ hemsResult.length > 1 ? ` Applicant ${result.applicant}` : "" }}
                            <br />({{ hem.hemBy.label }})
                        </strong>
                    </span>
                    <span v-if="Object.values(usingNetIncome).includes(true)">
                        <a @click.stop="openMessage('grossIncome')"
                           class="text-danger">
                            <i class="el-icon-info"></i>
                            Requires Gross Income
                        </a>
                    </span>
                    <span v-else>
                        {{
                            result[hem.hemBy.value].monthly_hems == 0 ? 'Below lowest HEM benchmark' :
                            `$${Number(result[hem.hemBy.value].monthly_hems).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}`
                        }}
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12"
             v-else>
            <div class="col-12 row-card d-flex justify-content-between py-3"
                 :class="{ 'bg-success': !isbelowHemsShared, 'bg-warning': isbelowHemsShared }">
                <span><strong style="text-transform: uppercase">HEM Benchmark Shared Household</strong><br />({{
                    hem.hemBy.label }})</span>
                <span>
                    {{
                        `$${Number(sharedHemsResult.monthly_hems || 0).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })}`
                    }}
                </span>
            </div>
        </div>
        <div class="col-12"
             v-if="(isBelowHems && !Object.values(usingNetIncome).includes(true)) || (note != null && note != '')">
            <div class="col-12 row-card d-flex justify-content-between py-3 mt-2 bg-warning">
                <span><strong style="text-transform: uppercase">Reason for being under HEM?</strong></span>
                <a @click.stop="openMessage('belowHem')"
                   class="text-danger">
                    <i class="el-icon-info"></i>
                    Declared Living expense below benchmark
                </a>
            </div>
            <el-input :class="`hems-alert`"
                      type="textarea"
                      v-model="note"
                      :autosize="{ minRows: 4 }"
                      placeholder="The broker should review these expenses with the customer and if these declared amounts are to be used, notes to explain why they are deemed reasonable should be included here"
                      @blur="saveNote"></el-input>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"

export default {
    name: "Hems",
    components: {},
    props: {
        applicants: {
            required: true,
        },
        maritalStatuses: {
            required: true,
        },
        totalMonthlyOtherExpense: {
            required: true,
        }
    },
    data() {
        return {
            hemsResult: [],
            sharedHemsResult: {},
            applicantsOld: {},
            applicantsExpenses: [],
            isShared: false,
            isBelowHems: false,
            below: [],
            isbelowHemsShared: false,
            usingNetIncome: {}
        }
    },
    computed: {
        ...mapGetters({
            hem: "hems",
        }),
        note: {
            get() {
                return this.hem.note
            },
            set(value) {
                this.setNote(value)
            },
        }
    },
    watch: {
        applicantsExpenses: {
            deep: true,
            handler: _.debounce(function () {
                this.hemsData()
            }, 3000),
        },
        applicants: {
            deep: true,
            handler: _.debounce(function () {
                let fetchHems = false
                this.applicants.forEach((applicant, index) => {

                    try {

                        if (_.get(this.applicantsOld, `${index}.maritalStatus`) == undefined) {
                            fetchHems = true
                        } else {
                            if (_.get(applicant, 'maritalStatus') != _.get(this.applicantsOld, `${index}.maritalStatus`)) {
                                fetchHems = true
                            }
                        }

                        if (_.get(this.applicantsOld, `${index}.dependents`) == undefined) {
                            fetchHems = true
                        } else {
                            if (_.get(applicant, 'dependents') != _.get(this.applicantsOld, `${index}.dependents`)) {
                                fetchHems = true
                            }
                        }

                        if (_.get(this.applicantsOld, `${index}.addressHistoryInfo`) == undefined) {
                            fetchHems = false
                        } else {
                            let current_address = applicant.addressHistoryInfo.find((address) => {
                                return address.is_current == 1
                            })

                            let current_address_copy = _.get(this.applicantsOld[index], 'addressHistoryInfo') && _.get(this.applicantsOld[index], 'addressHistoryInfo').find((address) => {
                                return address.is_current == 1
                            })

                            if (current_address && current_address_copy) {
                                if (current_address.addressComponents.postal_code != current_address_copy.addressComponents.postal_code) {
                                    fetchHems = true
                                }
                            }
                        }
                    } catch (error) {
                        console.error("Hems catch error", error)
                        fetchHems = false
                    }
                })
                if (fetchHems) {
                    this.hemsData()
                }
                this.expenses()
            }, 2000),
        },
        note: {
            handler() {
                this.$store.dispatch('applicationValidation/validateData', {
                    section: [
                        'expenses',
                        'financesSummary'
                    ],
                    data: this.applicants
                })
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.expenses()
        this.$bus.$on("Hem::reload", this.hemsData)
        this.setCommercial(false)
    },
    updated() { },
    activated() { },
    methods: {
        ...mapMutations({
            setStatus: "hems/setStatus",
            setNote: "hems/setNote",
            setCommercial: "hems/setCommercial",
        }),
        hemsData: _.debounce(function () {
            let data = []
            this.applicants.forEach((applicant, index) => {

                // Incomes
                let income_totals = this.getIncomesTotals(applicant)

                // Exclude from Income
                this.$delete(income_totals, "Spousal Offset Income")

                // Calculate Monthly Income
                let income_total = this.calculateTotals(income_totals)

                let marital_status = this.maritalStatuses.find((status) => {
                    return status.value == _.get(applicant, 'maritalStatus')
                })

                let details = {
                    applicant: index,
                    dependents: applicant.dependents,
                    shared_dependents: applicant.isSharingDependents,
                    incomes: income_total,
                }

                if (marital_status) {
                    details.marital_status = marital_status
                } else {
                    details.marital_status = 1
                }

                if (applicant.addressHistoryInfo) {
                    let current_address = applicant.addressHistoryInfo.find((address) => {
                        return address.is_current == 1
                    })

                    if (current_address) {
                        details.postcode = current_address.addressComponents.postal_code
                        if (current_address.parent_id || this.checkAddress(index, current_address.addressComponents.formatted_address)) {
                            details.sharing = true
                            this.isShared = true
                        } else {
                            details.sharing = false
                            this.isShared = false
                        }
                    } else {
                        details.postcode = "0800"
                        details.sharing = false
                    }
                }
                data.push(details)
            })

            this.getHemsResult(data)
            this.applicantsOld = this.copy(this.applicants)
            this.$store.dispatch('applicationValidation/validateData', {
                section: [
                    'expenses',
                    'financesSummary'
                ],
                data: this.applicants
            })
        }, 500),

        checkAddress(check, formatted_address) {
            let match = 0
            this.applicants.forEach((applicant, index) => {
                if (check != index) {
                    match = applicant.addressHistoryInfo.find((address) => {
                        return address.addressComponents.formatted_address == formatted_address
                    })
                }
            })
            return match
        },

        expenses() {
            let data = []
            this.applicants.forEach((applicant, index) => {
                // Expenses
                let expense_totals = this.getExpenseTotals(applicant)
                // Exclude from HEMS
                this.$delete(expense_totals, "Full Rent")
                this.$delete(expense_totals, "Personal Financial Liabilities")

                // Calculate Monthly Expenses
                let expense_total = this.calculateTotals(expense_totals)

                data[index] = expense_total
            })

            this.applicantsExpenses = data
        },

        getExpenseTotals(applicant) {
            let expense_total = {}
            Object.values(applicant.expandedFinancialDetails.expenses).forEach((expense) => {
                if (
                    expense.label != "Superannuation Payments" &&
                    expense.label != "Child Support" &&
                    expense.label != "Defaults Under Arrangement" &&
                    expense.label != "Other"
                ) {
                    let expenseValue = expense.value
                    let localCategoryTotal = 0
                    if (typeof expenseValue === "string") {
                        if (expenseValue == "") expenseValue = 0
                        expenseValue = parseFloat(Number(expenseValue).toFixed(2))
                    }
                    if (expense_total[expense.category] === undefined) {
                        expense_total[expense.category] = parseFloat(0)
                    }
                    if (expense.frequency === 4 || expense.frequency === "4") {
                        localCategoryTotal = expense_total[expense.category] + (expenseValue * 52) / 12
                    } else if (expense.frequency === 2 || expense.frequency === "2") {
                        localCategoryTotal = expense_total[expense.category] + (expenseValue * 26) / 12
                    } else if (expense.frequency === 1 || expense.frequency === "1") {
                        localCategoryTotal = expense_total[expense.category] + expenseValue
                    } else if (expense.frequency === 0.333333333 || expense.frequency === "0.333333333") {
                        localCategoryTotal = expense_total[expense.category] + expenseValue * (4 / 12)
                    } else {
                        localCategoryTotal = expense_total[expense.category] + expenseValue * (1 / 12)
                    }
                    expense_total[expense.category] = parseFloat(Number(localCategoryTotal).toFixed(2))
                }
            })

            return expense_total
        },

        getIncomesTotals(applicant) {
            let income_total = {}
            Object.values(applicant.expandedFinancialDetails.income).forEach((income) => {

                let grossYearly = _.get(income, 'grossYearly', 0);
                let incomeValue = income.value
                let localCategoryTotal = 0

                if (income_total[income.label] === undefined) {
                    income_total[income.label] = parseFloat(0)
                }

                if (!grossYearly) {

                    if (typeof incomeValue === "string") {
                        if (incomeValue == "") incomeValue = 0
                        incomeValue = parseFloat(Number(incomeValue).toFixed(2))
                    }
                    if (income.frequency === 4 || income.frequency === "4") {
                        localCategoryTotal = income_total[income.label] + (incomeValue * 52)
                    } else if (income.frequency === 2 || income.frequency === "2") {
                        localCategoryTotal = income_total[income.label] + (incomeValue * 26)
                    } else if (income.frequency === 1 || income.frequency === "1") {
                        localCategoryTotal = income_total[income.label] + (incomeValue * 12)
                    } else if (income.frequency === 0.333333333 || income.frequency === "0.333333333") {
                        localCategoryTotal = income_total[income.label] + (incomeValue * 4)
                    } else {
                        localCategoryTotal = income_total[income.label] + incomeValue
                    }
                    income_total[income.label] = parseFloat(Number(localCategoryTotal).toFixed(2))
                } else {
                    income_total[income.label] = grossYearly
                }
            })

            Object.values(applicant.employmentHistoryInfo).forEach((income, index) => {
                let ci = applicant.individualEmploymentInformation.findIndex((ief) => index == ief.employmentId)
                if (income.is_current == 1) {
                    let grossYearly = _.get(applicant.individualEmploymentInformation, `${ci}.grossYearly`, 0);
                    let localCategoryTotal = 0
                    let incomeValue = _.get(applicant.individualEmploymentInformation, `${ci}.value`)
                    let incomeFrequency = _.get(applicant.individualEmploymentInformation, `${ci}.frequency`)
                    let employerName = income.currentEmployer

                    if (typeof incomeValue === "string") {
                        if (incomeValue == "") incomeValue = 0
                        incomeValue = parseFloat(Number(incomeValue).toFixed(2))
                    }

                    if (!grossYearly) {
                        if (income_total[employerName] === undefined) {
                            income_total[employerName] = parseFloat(0)
                        }
                        if (incomeFrequency === 4 || incomeFrequency === "4") {
                            localCategoryTotal = income_total[employerName] + (incomeValue * 52) / 12
                        } else if (incomeFrequency === 2 || incomeFrequency === "2") {
                            localCategoryTotal = income_total[employerName] + (incomeValue * 26) / 12
                        } else if (incomeFrequency === 1 || incomeFrequency === "1") {
                            localCategoryTotal = income_total[employerName] + incomeValue
                        } else if (incomeFrequency === 0.333333333 || incomeFrequency === "0.333333333") {
                            localCategoryTotal = income_total[employerName] + incomeValue * (4 / 12)
                        } else {
                            localCategoryTotal = income_total[employerName] + incomeValue * (1 / 12)
                        }
                        income_total[employerName] = parseFloat(Number(localCategoryTotal).toFixed(2))
                    } else {
                        income_total[employerName] = grossYearly
                    }

                    this.usingNetIncome = Object.assign(this.usingNetIncome, { [index]: _.get(applicant.individualEmploymentInformation, `${ci}.grossYearly`, 0) != '0.00' && _.get(applicant.individualEmploymentInformation, `${ci}.grossYearly`, false) ? false : true });
                }
            })

            return income_total
        },

        getHemsResult(details) {

            let total_expenses = this.calculateTotals(this.applicantsExpenses);
            axios
                .post("/admin/hems", {
                    'applicants': details,
                    'application': `${this.$store.getters.appId}`,
                    'total_expenses': total_expenses,
                    'other_expenses': this.totalMonthlyOtherExpense,
                })
                .then((resp) => {
                    this.hemsResult = resp.data.results
                    this.belowHems()
                    if (this.isShared) {
                        this.sharedHemsResult = {
                            monthly_hems: resp.data.shared[this.hem.hemBy.value].monthly_hems,
                            total_expenses,
                        }
                        this.belowHemsShared()
                    }
                })
        },

        calculateTotals(obj) {
            let sum = 0
            for (const el in obj) {
                if (obj.hasOwnProperty(el)) {
                    sum += parseFloat(obj[el])
                }
            }
            return sum
        },

        copy(o) {
            var output, v, key
            output = Array.isArray(o) ? [] : {}
            for (key in o) {
                v = o[key]
                output[key] = typeof v === "object" ? this.copy(v) : v
            }
            return output
        },
        openMessage(type) {
            switch (type) {
                case 'belowHem':
                    this.$alert(
                        "The broker should review these expenses with the customer and if these declared amounts are to be used, notes to explain why they are deemed reasonable should be included here",
                        "Declared expenses are less than the HEM benchmark",
                        {
                            confirmButtonText: "OK",
                            type: "warning",
                            callback: (action) => { },
                        }
                    )
                    break;
                case 'grossIncome':
                    this.$alert(
                        "Household Expenditure Method (HEM) is calculated using the GROSS income of the household, using NET will result in lower than expected income reporting.",
                        "Gross Income Required",
                        {
                            confirmButtonText: "OK",
                            type: "warning",
                            callback: (action) => { },
                        }
                    )
                    break;
            }
        },
        saveNote() {
            this.$tenant.put(`/api/applications/${this.$store.getters.appId}/part-update`, {
                hem_note: this.$store.getters.hems.note,
            }).catch(err => {
                err.output()
            })
        },
        belowHems() {
            let applicant = [false]
            if (this.hemsResult.length > 0) {
                this.hemsResult.forEach((result, index) => {
                    if (this.applicantsExpenses[index] >= result[this.hem.hemBy.value].monthly_hems) {
                        this.below[index] = false
                        applicant[index] = true
                    } else {
                        this.below[index] = true
                        applicant[index] = false
                    }
                })
            } else {
                this.below = true
                applicant = [false]
            }

            this.$store.dispatch('hems/setApplicantStatus', applicant)

            if (_.size(this.below) > 0) {
                this.below.forEach((app, key) => {
                    if (!app) {
                        this.setStatus(false)
                        this.$emit("hemStatus", false)
                    } else {
                        this.setStatus(true)
                        this.$emit("hemStatus", true)
                    }
                })
            }

            this.isBelowHems = this.below.includes(true)
        },
        belowHemsShared() {
            let below = true
            let applicant = this.applicants.map(applicant => false)
            if (this.isShared) {
                if (this.calculateTotals(this.applicantsExpenses) >= this.sharedHemsResult.monthly_hems) {
                    below = false
                    applicant = this.applicants.map(applicant => true)
                } else {
                    below = true
                    applicant = this.applicants.map(applicant => false)
                }
                this.setStatus(below)
                this.$emit("hemStatus", below)
                this.$store.dispatch('hems/setApplicantStatus', applicant)
                this.isBelowHems = below
                this.isbelowHemsShared = below
            }
        },
    },
}
</script>

<style lang="scss">
// @import '@assets/sass/backend/_core-variables.scss';
.hems-alert {
    .el-textarea__inner {
        &::placeholder {
            color: #e20909 !important;
        }

        &::-webkit-input-placeholder {
            color: #e20909 !important;
        }

        &::-moz-placeholder {
            color: #e20909 !important;
        }

        &:-ms-input-placeholder {
            /** notice that ie has only a single colon) */
            color: #e20909 !important;
        }

        &::-webkit-input-placeholder {
            color: #e20909 !important;
        }
    }
}</style>
